namespace GeniuzPOS.Administration {
    export class SysGroupColumns {
        static columnsKey = 'Administration.SysGroup';
    }
}
